<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">平台装饰</div>

      <div class="search-wrapper">
         <el-form :inline="true" :model="queryForm">
            <el-form-item label="装饰说明">
               <el-input v-model="queryForm.decorationDesc" placeholder="模糊搜索" style="width: 200px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="装饰位置">
               <el-select v-model="queryForm.decorationPosition" style="width: 200px;">
                  <el-option label="全部" :value="0"></el-option>
                  <el-option v-for="item in positionOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="状态">
               <el-select v-model="queryForm.displayStatus" style="width: 160px;">
                  <el-option label="全部" :value="0"></el-option>
                  <el-option label="生效中" :value="1"></el-option>
                  <el-option label="已停用" :value="2"></el-option>
                  <el-option label="待生效" :value="3"></el-option>
               </el-select>
            </el-form-item>
         </el-form>
         <el-button @click="clickReset">重置</el-button>
         <el-button type="primary" @click="queryList">查询</el-button>
      </div>

      <div class="action-wrapper">
         <el-button type="primary" @click="clickAdd">+ 新增</el-button>
      </div>

      <div class="content-wrapper">
         <el-table border :data="listData" style="width: 100%;">
            <el-table-column align="center" label="创建ID" prop="id" width="100"></el-table-column>
            <el-table-column align="center" label="装饰位置" width="200">
               <template scope="{ row }">{{ getPositionName(row.decorationPosition) }}</template>
            </el-table-column>
            <el-table-column align="center" label="装饰说明" prop="decorationDesc" min-width="140"></el-table-column>
            <el-table-column align="center" label="图片" min-width="180">
               <template scope="{ row }">
                  <div class="img-cell">
                     <!-- 单图（浮窗5/6）：直接显示缩略图 -->
                     <template v-if="[5,6].indexOf(row.decorationPosition) !== -1">
                        <el-popover v-if="row.singleImage && row.singleImage.imageUrl"
                           placement="right" title="大图浏览" trigger="hover">
                           <img width="300" :src="row.singleImage.imageUrl" alt="" />
                           <img slot="reference" class="list-img" :src="row.singleImage.imageUrl" alt="" />
                        </el-popover>
                        <span v-else>-</span>
                     </template>
                     <!-- 单图（1-appLogo，8-启动页）：缩略图 + hover大图 -->
                     <template v-else-if="[1,8].indexOf(row.decorationPosition) !== -1">
                        <el-popover v-if="row.singleImage && row.singleImage.imageUrl"
                           placement="right" title="大图浏览" trigger="hover">
                           <img width="300" :src="row.singleImage.imageUrl" alt="" />
                           <img slot="reference" class="list-img" :src="row.singleImage.imageUrl" alt="" />
                        </el-popover>
                        <span v-else>-</span>
                     </template>
                     <!-- 起点/终点定位图标：2-校园跑，3-户外跑 -->
                     <template v-else-if="[2,3].indexOf(row.decorationPosition) !== -1">
                        <div v-if="row.runEndpointIcons" class="multi-img-row">
                           <el-popover v-if="row.runEndpointIcons.startPointImage"
                              placement="right" title="起点图标" trigger="hover">
                              <img width="300" :src="row.runEndpointIcons.startPointImage" alt="" />
                              <img slot="reference" class="thumb-img" :src="row.runEndpointIcons.startPointImage" alt="" />
                           </el-popover>
                           <el-popover v-if="row.runEndpointIcons.endPointImage"
                              placement="right" title="终点图标" trigger="hover">
                              <img width="300" :src="row.runEndpointIcons.endPointImage" alt="" />
                              <img slot="reference" class="thumb-img" :src="row.runEndpointIcons.endPointImage" alt="" />
                           </el-popover>
                           <el-popover v-if="row.runEndpointIcons.locationIcon"
                              placement="right" title="定位图标" trigger="hover">
                              <img width="300" :src="row.runEndpointIcons.locationIcon" alt="" />
                              <img slot="reference" class="thumb-img" :src="row.runEndpointIcons.locationIcon" alt="" />
                           </el-popover>
                        </div>
                        <span v-else>-</span>
                     </template>
                     <!-- 点位图片：4 -->
                     <template v-else-if="row.decorationPosition === 4">
                        <div v-if="row.pointImages && row.pointImages.length" class="multi-img-row">
                           <template v-for="(point, idx) in row.pointImages">
                              <el-popover v-if="point.notPassedUrl" :key="'np'+idx"
                                 placement="right" title="未通过" trigger="hover">
                                 <img width="300" :src="point.notPassedUrl" alt="" />
                                 <img slot="reference" class="thumb-img" :src="point.notPassedUrl" alt="" />
                              </el-popover>
                              <el-popover v-if="point.preparingUrl" :key="'pr'+idx"
                                 placement="right" title="准备中" trigger="hover">
                                 <img width="300" :src="point.preparingUrl" alt="" />
                                 <img slot="reference" class="thumb-img" :src="point.preparingUrl" alt="" />
                              </el-popover>
                              <el-popover v-if="point.passedUrl" :key="'pa'+idx"
                                 placement="right" title="已通过" trigger="hover">
                                 <img width="300" :src="point.passedUrl" alt="" />
                                 <img slot="reference" class="thumb-img" :src="point.passedUrl" alt="" />
                              </el-popover>
                           </template>
                        </div>
                        <span v-else>-</span>
                     </template>
                     <!-- 主题配置：7 -->
                     <template v-else-if="row.decorationPosition === 7">
                        <div v-if="row.themeContent" class="multi-img-row">
                           <template v-if="row.themeContent.backgrounds">
                              <el-popover v-if="row.themeContent.backgrounds.tabBarBg"
                                 placement="right" title="底部导航背景" trigger="hover">
                                 <img width="300" :src="row.themeContent.backgrounds.tabBarBg" alt="" />
                                 <img slot="reference" class="thumb-img" :src="row.themeContent.backgrounds.tabBarBg" alt="" />
                              </el-popover>
                              <el-popover v-if="row.themeContent.backgrounds.homePageBg"
                                 placement="right" title="首页背景" trigger="hover">
                                 <img width="300" :src="row.themeContent.backgrounds.homePageBg" alt="" />
                                 <img slot="reference" class="thumb-img" :src="row.themeContent.backgrounds.homePageBg" alt="" />
                              </el-popover>
                              <el-popover v-if="row.themeContent.backgrounds.myPageBg"
                                 placement="right" title="我的页面背景" trigger="hover">
                                 <img width="300" :src="row.themeContent.backgrounds.myPageBg" alt="" />
                                 <img slot="reference" class="thumb-img" :src="row.themeContent.backgrounds.myPageBg" alt="" />
                              </el-popover>
                              <el-popover v-if="row.themeContent.backgrounds.squarePageBg"
                                 placement="right" title="广场页背景" trigger="hover">
                                 <img width="300" :src="row.themeContent.backgrounds.squarePageBg" alt="" />
                                 <img slot="reference" class="thumb-img" :src="row.themeContent.backgrounds.squarePageBg" alt="" />
                              </el-popover>
                              <el-popover v-if="row.themeContent.backgrounds.sportsPageBg"
                                 placement="right" title="运动页背景" trigger="hover">
                                 <img width="300" :src="row.themeContent.backgrounds.sportsPageBg" alt="" />
                                 <img slot="reference" class="thumb-img" :src="row.themeContent.backgrounds.sportsPageBg" alt="" />
                              </el-popover>
                           </template>
                           <template v-if="row.themeContent.bottomTabs && row.themeContent.bottomTabs.length">
                              <template v-for="(tab, tIdx) in row.themeContent.bottomTabs">
                                 <el-popover v-if="tab.unselectedIcon" :key="'u'+tIdx"
                                    placement="right" title="未选中图标" trigger="hover">
                                    <img width="300" :src="tab.unselectedIcon" alt="" />
                                    <img slot="reference" class="thumb-img" :src="tab.unselectedIcon" alt="" />
                                 </el-popover>
                                 <el-popover v-if="tab.selectedIcon" :key="'s'+tIdx"
                                    placement="right" title="选中图标" trigger="hover">
                                    <img width="300" :src="tab.selectedIcon" alt="" />
                                    <img slot="reference" class="thumb-img" :src="tab.selectedIcon" alt="" />
                                 </el-popover>
                              </template>
                           </template>
                        </div>
                        <span v-else>-</span>
                     </template>
                     <span v-else>-</span>
                  </div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="生效时间" min-width="220">
               <template scope="{ row }">
                  <span>{{ formatTime(row.startTime) }} ~ {{ formatTime(row.endTime) }}</span>
               </template>
            </el-table-column>
            <el-table-column align="center" label="跳转链接" min-width="160">
               <template scope="{ row }">
                  <span>{{ row.redirectUrl || '-' }}</span>
               </template>
            </el-table-column>
            <el-table-column align="center" label="操作时间" min-width="160">
               <template scope="{ row }">
                  <span>{{ formatTime(row.updateTime) }}</span>
               </template>
            </el-table-column>
            <el-table-column align="center" label="状态" width="90">
               <template scope="{ row }">
                  <span :class="getDisplayStatusClass(row.displayStatus)">
                     {{ row.displayStatusName || getDisplayStatusText(row.displayStatus) }}
                  </span>
               </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="140" fixed="right">
               <template scope="{ row }">
                  <el-button
                     v-if="row.status !== 2"
                     type="text"
                     style="color: #409eff;"
                     @click="clickDisable(row)">停用</el-button>
                  <template v-else>
                     <el-button type="text" style="color: #409eff;" @click="clickEnable(row)">启用</el-button>
                     <el-button type="text" style="color: #409eff;" @click="clickEdit(row)">编辑</el-button>
                  </template>
               </template>
            </el-table-column>
         </el-table>
      </div>

      <div class="pagination-wrapper">
         <el-pagination
            v-show="total > 0"
            layout="total, prev, pager, next, jumper"
            :current-page="queryForm.pageNumber"
            :page-size="queryForm.pageSize"
            :total="total"
            @current-change="changeCurrentPage">
         </el-pagination>
      </div>

      <!-- 新增弹框 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="680px"
         custom-class="platform-decoration-dialog"
         :modal-append-to-body="false" :close-on-click-modal="false" @close="onDialogClose">
         <el-form ref="dialogForm" :model="dialogForm" :rules="dialogRules" label-width="110px">
            <el-form-item label="装饰说明" prop="decorationDesc">
               <el-input v-model="dialogForm.decorationDesc" placeholder="请输入装饰说明，不超过20字"
                  maxlength="20" style="width: 340px;"></el-input>
               <div class="form-hint">仅在后台展示，不在APP展示</div>
            </el-form-item>

            <el-form-item label="装饰位置" prop="decorationPosition">
               <el-select v-model="dialogForm.decorationPosition" style="width: 220px;" @change="onPositionChange">
                  <el-option v-for="item in positionOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
               </el-select>
            </el-form-item>

            <!-- 单图（1-APP logo，8-启动页） -->
            <template v-if="[1,8].indexOf(dialogForm.decorationPosition) !== -1">
               <el-form-item>
                  <template slot="label"><span class="req-star">*</span>图片</template>
                  <UploadImg :imgUrl.sync="dialogForm.singleImage.imageUrl" />
                  <div class="form-hint form-hint-warn">上传图片不生效，需要开发打包发版，图片提交前请提供给开发</div>
               </el-form-item>
            </template>

            <!-- 单图 + 跳转链接（5-校园跑浮窗，6-户外跑浮窗） -->
            <template v-if="[5,6].indexOf(dialogForm.decorationPosition) !== -1">
               <el-form-item>
                  <template slot="label"><span class="req-star">*</span>图片</template>
                  <UploadImg :imgUrl.sync="dialogForm.singleImage.imageUrl" />
               </el-form-item>
               <el-form-item>
                  <template slot="label"><span class="req-star">*</span>跳转链接</template>
                  <el-input v-model="dialogForm.redirectUrl" placeholder="请输入" style="width: 340px;"></el-input>
               </el-form-item>
               <el-form-item label="是否弹窗提示" required class="popup-prompt-form-item">
                  <div class="popup-prompt-row">
                     <el-radio-group v-model="dialogForm.isPopup">
                        <el-radio :label="0">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                     </el-radio-group>
                     <el-input
                        v-if="dialogForm.isPopup === 1"
                        v-model="dialogForm.popupContent"
                        maxlength="20"
                        placeholder="请填写弹窗内容，最多20个字"
                        class="popup-prompt-input"
                     />
                     <div class="popup-prompt-example">
                        <span class="popup-prompt-example-label">示例</span>
                        <img :src="popupPromptExampleImg" alt="弹窗示例" />
                     </div>
                  </div>
               </el-form-item>
            </template>

            <!-- 起点终点定位图标（2-校园跑，3-户外跑） -->
            <template v-if="[2,3].indexOf(dialogForm.decorationPosition) !== -1">
               <el-form-item>
                  <template slot="label"><span class="req-star">*</span>起点图片</template>
                  <SUpload v-model="dialogForm.runEndpointIcons.startPointImage" accept="image/*" type="drag" :size="50" :show-file-list="false" />
                  <div class="form-hint">尺寸要求32*32，最大50KB，优先SVG其次png</div>
               </el-form-item>
               <el-form-item>
                  <template slot="label"><span class="req-star">*</span>终点图片</template>
                  <SUpload v-model="dialogForm.runEndpointIcons.endPointImage" accept="image/*" type="drag" :size="50" :show-file-list="false" />
                  <div class="form-hint">尺寸要求32*32，最大50KB，优先SVG其次png</div>
               </el-form-item>
               <el-form-item>
                  <template slot="label"><span class="req-star">*</span>定位图标</template>
                  <SUpload v-model="dialogForm.runEndpointIcons.locationIcon" accept="image/*" type="drag" :size="50" :show-file-list="false" />
                  <div class="form-hint">尺寸要求32*32，最大50KB，优先SVG其次png</div>
               </el-form-item>
               <div class="form-hint form-hint-warn" style="margin: -10px 0 12px 90px; color: #f56c6c;">以上三项至少上传一个</div>
            </template>

            <!-- 点位图片（4） -->
            <template v-if="dialogForm.decorationPosition === 4">
               <el-form-item>
                  <template slot="label"><span class="req-star">*</span>图片</template>
                  <el-table :data="dialogForm.pointImages" border style="width: 100%;" size="small">
                     <el-table-column label="位置" prop="label" width="70" align="center"></el-table-column>
                     <el-table-column align="center" :render-header="() => renderRequiredHeader('未经过')">
                        <template scope="{ row }">
                           <SUpload v-model="row.notPassedUrl" accept="image/*" type="drag" :size="50" :show-file-list="false" />
                        </template>
                     </el-table-column>
                     <el-table-column align="center" :render-header="() => renderRequiredHeader('准备中（下一个点位）')">
                        <template scope="{ row }">
                           <span v-if="!row.hasPreparing">—</span>
                           <SUpload v-else v-model="row.preparingUrl" accept="image/*" type="drag" :size="50" :show-file-list="false" />
                        </template>
                     </el-table-column>
                     <el-table-column align="center" :render-header="() => renderRequiredHeader('已经过')">
                        <template scope="{ row }">
                           <SUpload v-model="row.passedUrl" accept="image/*" type="drag" :size="50" :show-file-list="false" />
                        </template>
                     </el-table-column>
                  </el-table>
                  <div class="form-hint">点位图片尺寸要求32*32，最大50KB，优先SVG其次png</div>
               </el-form-item>
            </template>

            <!-- 主题配置（7） -->
            <template v-if="dialogForm.decorationPosition === 7">
               <el-form-item label="底部tab">
                  <div class="theme-tab-wrap">
                     <div class="theme-tab-box" v-for="(tab, idx) in dialogForm.themeContent.bottomTabs" :key="idx">
                        <i class="el-icon-circle-close theme-tab-close-btn" @click="removeTab(idx)"></i>
                        <el-input v-model="tab.code" placeholder="请输入Code" style="width: 100%; margin-bottom: 8px;">
                           <template slot="prepend"><span class="req-star">*</span></template>
                        </el-input>
                        <div class="theme-tab-imgs">
                           <div class="theme-tab-img-item">
                              <span class="theme-tab-img-label"><span class="req-star">*</span>未选中状态</span>
                              <UploadImg :imgUrl.sync="tab.unselectedIcon" />
                           </div>
                           <div class="theme-tab-img-item">
                              <span class="theme-tab-img-label"><span class="req-star">*</span>已选中状态</span>
                              <UploadImg :imgUrl.sync="tab.selectedIcon" />
                           </div>
                           <div class="theme-tab-img-item">
                              <span class="theme-tab-img-label">回到顶部按钮</span>
                              <UploadImg :imgUrl.sync="tab.backToTopIcon" />
                           </div>
                        </div>
                        <div class="theme-tab-tips">（尺寸：188*116，jpg、png）</div>
                     </div>
                     <el-button type="primary" style="width: 100%;" @click="addTab">添加</el-button>
                  </div>
               </el-form-item>
               <el-form-item label="背景图">
                  <div class="theme-bg-row">
                     <div class="theme-bg-item">
                        <div class="theme-bg-label">tab栏底部背景</div>
                        <UploadImg :imgUrl.sync="dialogForm.themeContent.backgrounds.tabBarBg" />
                        <div class="form-hint">（尺寸：750*166，jpg、png）</div>
                     </div>
                     <div class="theme-bg-item">
                        <div class="theme-bg-label">首页背景</div>
                        <UploadImg :imgUrl.sync="dialogForm.themeContent.backgrounds.homePageBg" />
                        <div class="form-hint">支持jpg、png、gif</div>
                     </div>
                     <div class="theme-bg-item">
                        <div class="theme-bg-label">我的页面背景</div>
                        <UploadImg :imgUrl.sync="dialogForm.themeContent.backgrounds.myPageBg" />
                        <div class="form-hint">支持jpg、png、gif</div>
                     </div>
                     <div class="theme-bg-item">
                        <div class="theme-bg-label">广场页背景</div>
                        <UploadImg :imgUrl.sync="dialogForm.themeContent.backgrounds.squarePageBg" />
                        <div class="form-hint">支持jpg、png、gif</div>
                     </div>
                     <div class="theme-bg-item">
                        <div class="theme-bg-label">运动页背景</div>
                        <UploadImg :imgUrl.sync="dialogForm.themeContent.backgrounds.sportsPageBg" />
                        <div class="form-hint">支持jpg、png、gif</div>
                     </div>
                  </div>
               </el-form-item>
            </template>

            <el-form-item label="生效时间" prop="timeRange">
               <div class="time-range-row">
                  <el-date-picker
                     v-model="dialogForm.startTime"
                     type="datetime"
                     placeholder="开始时间"
                     value-format="yyyy-MM-dd HH:mm:ss"
                     style="width: 190px;"
                     @change="onTimeChange">
                  </el-date-picker>
                  <span class="time-range-sep">To</span>
                  <el-date-picker
                     v-model="dialogForm.endTime"
                     type="datetime"
                     placeholder="结束时间"
                     value-format="yyyy-MM-dd HH:mm:ss"
                     style="width: 190px;"
                     @change="onTimeChange">
                  </el-date-picker>
               </div>
            </el-form-item>
         </el-form>

         <div slot="footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" :loading="submitLoading" @click="submitDialog">确认</el-button>
         </div>
      </el-dialog>
   </div>
</template>

<script>
import UploadImg from '../../../../components/common/UploadImg.vue';
import SUpload from '../../../../components/common/SUpload.vue';
import popupPromptExampleImg from '../../../../assets/popup-prompt-example.png';

// [平台装饰]
const LOG_TAG = '[平台装饰]';

const POSITION_OPTIONS = [
   { label: '校园跑起点终点定位图标', value: 2 },
   { label: '户外跑起点终点定位图标', value: 3 },
   { label: '点位图片', value: 4 },
   { label: '校园跑浮窗', value: 5 },
   { label: '户外跑浮窗', value: 6 },
   { label: '主题配置', value: 7 },
];

const DISPLAY_STATUS_MAP = {
   1: '生效中',
   2: '已停用',
   3: '待生效',
   4: '已过期',
};

const POINT_IMAGE_ROWS = [
   { pointName: 'FIRST_POINT',    label: '点位1', hasPreparing: true },
   { pointName: 'SECOND_POINT',   label: '点位2', hasPreparing: true },
   { pointName: 'THIRD_POINT',    label: '点位3', hasPreparing: true },
   { pointName: 'FOURTH_POINT',   label: '点位4', hasPreparing: true },
   { pointName: 'FIFTH_POINT',    label: '点位5', hasPreparing: true },
   { pointName: 'NORMAL_POINT',   label: '普通点', hasPreparing: false },
   { pointName: 'REQUIRED_POINT', label: '必经点', hasPreparing: false },
];

function buildInitialDialogForm() {
   return {
      decorationDesc: '',
      decorationPosition: null,
      startTime: null,
      endTime: null,
      timeRange: null,
      redirectUrl: '',
      linkType: 0,
      isPopup: 0,
      popupContent: '',
      singleImage: { imageUrl: '' },
      runEndpointIcons: { startPointImage: '', endPointImage: '', locationIcon: '' },
      pointImages: POINT_IMAGE_ROWS.map(row => ({
         ...row,
         notPassedUrl: '',
         preparingUrl: '',
         passedUrl: '',
      })),
      themeContent: {
         bottomTabs: [],
         backgrounds: { tabBarBg: '', homePageBg: '', myPageBg: '', squarePageBg: '', sportsPageBg: '' },
      },
   };
}

export default {
   components: { UploadImg, SUpload },

   data() {
      return {
         loading: false,
         queryForm: {
            decorationDesc: '',
            decorationPosition: 0,
            displayStatus: 0,
            pageNumber: 1,
            pageSize: 10,
         },
         total: 0,
         listData: [],
         positionOptions: POSITION_OPTIONS,

         dialogVisible: false,
         dialogTitle: '新增平台装饰',
         editId: null,
         submitLoading: false,
         popupPromptExampleImg,
         dialogForm: buildInitialDialogForm(),
         dialogRules: {
            decorationDesc: [{ required: true, message: '请输入装饰说明', trigger: 'blur' }],
            decorationPosition: [{
               required: true,
               validator: (rule, value, callback) => {
                  if (!value) callback(new Error('请选择装饰位置'));
                  else callback();
               },
               trigger: 'change',
            }],
            timeRange: [{
               required: true,
               validator: (rule, value, callback) => {
                  if (!this.dialogForm.startTime || !this.dialogForm.endTime) callback(new Error('请选择生效时间'));
                  else callback();
               },
               trigger: 'change',
            }],
         },
      };
   },

   mounted() {
      this.queryList();
   },

   methods: {
      getPositionName(position) {
         const found = POSITION_OPTIONS.find(item => item.value === position);
         return found ? found.label : '-';
      },

      getDisplayStatusText(status) {
         return DISPLAY_STATUS_MAP[status] || '-';
      },

      getDisplayStatusClass(status) {
         const map = { 1: 'status-active', 2: 'status-disabled', 3: 'status-pending', 4: 'status-expired' };
         return map[status] || '';
      },

      formatTime(timestamp) {
         if (!timestamp) return '-';
         const date = new Date(typeof timestamp === 'number' && timestamp < 1e12 ? timestamp * 1000 : timestamp);
         const pad = n => String(n).padStart(2, '0');
         return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
      },

      // 统一转换为 yyyy-MM-dd HH:mm:ss，兼容 时间戳(秒/毫秒) / ISO字符串 / Date对象 / 已格式化字符串
      formatDatetime(val) {
         if (!val) return '';
         const pad = n => String(n).padStart(2, '0');
         let d;
         if (val instanceof Date) {
            d = val;
         } else if (typeof val === 'number') {
            // 秒级时间戳（< 1e12）转毫秒
            d = new Date(val < 1e12 ? val * 1000 : val);
         } else if (typeof val === 'string') {
            if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(val)) return val;
            d = new Date(val);
         } else {
            return '';
         }
         if (isNaN(d.getTime())) return '';
         return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
      },

      queryList() {
         console.log(LOG_TAG, '查询列表', this.queryForm);
         this.loading = true;
         this.$http({
            method: 'POST',
            url: this.$util.domain + '/adminapi/v70310/platformDecoration/list',
            body: JSON.stringify({ ...this.queryForm }),
         }).then((res) => {
            if (res.body.error === 10000) {
               this.total = res.body.data.count || 0;
               this.listData = res.body.data.list || [];
            } else {
               this.$message.error(res.body.message || '请求错误');
            }
         }).catch((err) => {
            console.error(LOG_TAG, '查询列表失败', err);
            this.total = 0;
            this.listData = [];
         }).finally(() => {
            this.loading = false;
         });
      },

      clickReset() {
         this.queryForm = { decorationDesc: '', decorationPosition: 0, displayStatus: 0, pageNumber: 1, pageSize: 10 };
         this.queryList();
      },

      clickAdd() {
         this.editId = null;
         this.dialogTitle = '新增平台装饰';
         this.dialogForm = buildInitialDialogForm();
         this.dialogVisible = true;
      },

      clickEdit(row) {
         console.log(LOG_TAG, '编辑装饰', row.id);
         this.loading = true;
         this.$http({
            method: 'GET',
            url: this.$util.domain + '/adminapi/v70310/platformDecoration/detail',
            params: { id: row.id },
         }).then((res) => {
            if (res.body.error === 10000) {
               const d = res.body.data;
               const form = buildInitialDialogForm();
               form.decorationDesc = d.decorationDesc || '';
               form.decorationPosition = d.decorationPosition;
               form.startTime = d.startTime ? this.formatDatetime(d.startTime) : null;
               form.endTime = d.endTime ? this.formatDatetime(d.endTime) : null;
               form.redirectUrl = d.redirectUrl || '';
               form.linkType = d.linkType || 0;
               form.isPopup = d.isPopup != null ? d.isPopup * 1 : 0;
               form.popupContent = d.popupContent || '';
               if (d.singleImage) form.singleImage = { ...d.singleImage };
               if (d.runEndpointIcons) form.runEndpointIcons = { ...d.runEndpointIcons };
               if (d.pointImages && d.pointImages.length) {
                  form.pointImages = POINT_IMAGE_ROWS.map(row => {
                     const found = d.pointImages.find(p => p.pointName === row.pointName) || {};
                     return { ...row, notPassedUrl: found.notPassedUrl || '', preparingUrl: found.preparingUrl || '', passedUrl: found.passedUrl || '' };
                  });
               }
               if (d.themeContent) {
                  form.themeContent = {
                     bottomTabs: (d.themeContent.bottomTabs || []).map(t => ({ ...t })),
                     backgrounds: { ...d.themeContent.backgrounds },
                  };
               }
               this.editId = d.id;
               this.dialogTitle = '编辑平台装饰';
               this.dialogForm = form;
               this.dialogVisible = true;
            } else {
               this.$message.error(res.body.message || '获取详情失败');
            }
         }).catch((err) => {
            console.error(LOG_TAG, '获取详情失败', err);
            this.$message.error('获取详情失败，请联系管理员');
         }).finally(() => {
            this.loading = false;
         });
      },

      onDialogClose() {
         this.$refs.dialogForm && this.$refs.dialogForm.clearValidate();
      },

      onPositionChange() {
         const { decorationDesc, decorationPosition, startTime, endTime } = this.dialogForm;
         this.dialogForm = buildInitialDialogForm();
         this.dialogForm.decorationDesc = decorationDesc;
         this.dialogForm.decorationPosition = decorationPosition;
         this.dialogForm.startTime = startTime;
         this.dialogForm.endTime = endTime;
      },

      onTimeChange() {
         this.$refs.dialogForm && this.$refs.dialogForm.validateField('timeRange');
      },

      renderRequiredHeader(label) {
         const h = this.$createElement;
         return h('span', [
            h('span', { style: { color: '#f56c6c', marginRight: '2px' } }, '*'),
            label,
         ]);
      },

      addTab() {
         this.dialogForm.themeContent.bottomTabs.push({
            code: '', unselectedIcon: '', selectedIcon: '', backToTopIcon: '',
         });
      },

      removeTab(idx) {
         this.dialogForm.themeContent.bottomTabs.splice(idx, 1);
      },

      // 根据装饰位置校验图片字段，返回错误信息字符串或 null
      validateImageFields() {
         const form = this.dialogForm;
         const pos = form.decorationPosition;

         // 1/8 APP logo / 启动页：图片必填
         if ([1, 8].indexOf(pos) !== -1) {
            if (!form.singleImage.imageUrl) return '请上传图片';
         }

         // 5/6 浮窗：图片、跳转链接必填
         if ([5, 6].indexOf(pos) !== -1) {
            if (!form.singleImage.imageUrl) return '请上传图片';
            if (!form.redirectUrl) return '请输入跳转链接';
            if (form.isPopup === 1 && !form.popupContent.trim()) return '请填写弹窗内容';
         }

         // 2/3 起终点定位图标：至少上传一个
         if ([2, 3].indexOf(pos) !== -1) {
            const icons = form.runEndpointIcons;
            if (!icons.startPointImage && !icons.endPointImage && !icons.locationIcon) {
               return '起点图片、终点图片、定位图标至少上传一个';
            }
         }

         // 4 点位图片：每个点位各状态图片全部必填
         // 规则：配置了未经过 → 必须配准备中（点位1-5）和已经过；普通点/必经点配了未经过 → 必须配已经过
         if (pos === 4) {
            for (const row of form.pointImages) {
               const hasNotPassed = !!row.notPassedUrl;
               const hasPassed = !!row.passedUrl;
               const hasPreparing = row.hasPreparing ? !!row.preparingUrl : true;

               if (hasNotPassed || hasPassed || (row.hasPreparing && !!row.preparingUrl)) {
                  // 只要填了任意一项，本点位所有必填项都要完整
                  if (!row.notPassedUrl) return `${row.label}：请上传未经过图片`;
                  if (!row.passedUrl) return `${row.label}：请上传已经过图片`;
                  if (row.hasPreparing && !row.preparingUrl) return `${row.label}：请上传准备中图片`;
               }
            }
            // 全部点位必填
            for (const row of form.pointImages) {
               if (!row.notPassedUrl) return `${row.label}：请上传未经过图片`;
               if (!row.passedUrl) return `${row.label}：请上传已经过图片`;
               if (row.hasPreparing && !row.preparingUrl) return `${row.label}：请上传准备中图片`;
            }
         }

         // 7 主题配置：已添加的每个 tab 项所有字段必填
         if (pos === 7) {
            const tabs = form.themeContent.bottomTabs;
            for (let i = 0; i < tabs.length; i++) {
               const tab = tabs[i];
               const n = i + 1;
               if (!tab.code) return `底部tab第${n}项：请输入Code`;
               if (!tab.unselectedIcon) return `底部tab第${n}项：请上传未选中状态图标`;
               if (!tab.selectedIcon) return `底部tab第${n}项：请上传已选中状态图标`;
            }
         }

         return null;
      },

      submitDialog() {
         this.$refs.dialogForm.validate(valid => {
            if (!valid) {
               this.$message.warning('请填写完整必填项');
               return;
            }

            const imageError = this.validateImageFields();
            if (imageError) {
               this.$message.warning(imageError);
               return;
            }

            const form = this.dialogForm;
            const params = {
               decorationDesc: form.decorationDesc,
               decorationPosition: form.decorationPosition,
               startTime: this.formatDatetime(form.startTime),
               endTime: this.formatDatetime(form.endTime),
               linkType: form.linkType,
               redirectUrl: form.redirectUrl,
            };
            if (this.editId) params.id = this.editId;

            if ([1, 8].indexOf(form.decorationPosition) !== -1) {
               params.singleImage = form.singleImage;
            } else if ([5, 6].indexOf(form.decorationPosition) !== -1) {
               params.singleImage = form.singleImage;
               params.linkType = 2;
               params.redirectUrl = form.redirectUrl;
               params.isPopup = form.isPopup * 1;
               params.popupContent = form.isPopup === 1 ? form.popupContent.trim() : '';
            } else if ([2, 3].indexOf(form.decorationPosition) !== -1) {
               params.runEndpointIcons = form.runEndpointIcons;
            } else if (form.decorationPosition === 4) {
               params.pointImages = form.pointImages.map(row => ({
                  pointName: row.pointName,
                  notPassedUrl: row.notPassedUrl,
                  preparingUrl: row.hasPreparing ? row.preparingUrl : '',
                  passedUrl: row.passedUrl,
               }));
            } else if (form.decorationPosition === 7) {
               params.themeContent = form.themeContent;
            }

            console.log(LOG_TAG, '提交新增', params);
            this.submitLoading = true;
            this.$http({
               method: 'POST',
               url: this.$util.domain + '/adminapi/v70310/platformDecoration/addOrEdit',
               body: JSON.stringify(params),
            }).then((res) => {
               if (res.body.error === 10000) {
                  this.$message.success(this.editId ? '编辑成功' : '新增成功');
                  this.dialogVisible = false;
                  this.queryList();
               } else {
                  this.$message.error(res.body.message || (this.editId ? '编辑失败' : '新增失败'));
               }
            }).catch((err) => {
               console.error(LOG_TAG, this.editId ? '编辑失败' : '新增失败', err);
               this.$message.error((this.editId ? '编辑' : '新增') + '失败，请联系管理员');
            }).finally(() => {
               this.submitLoading = false;
            });
         });
      },

      clickDisable(row) {
         this.$confirm('确定要停用该装饰吗？停用后用户端将无法看到该装饰内容', '停用', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
         }).then(() => {
            console.log(LOG_TAG, '停用装饰', row.id);
            this.changeStatus(row.id, 2);
         }).catch(() => {});
      },

      clickEnable(row) {
         this.$confirm('确定要启用该装饰吗？', '启用', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
         }).then(() => {
            console.log(LOG_TAG, '启用装饰', row.id);
            this.changeStatus(row.id, 1);
         }).catch(() => {});
      },

      changeStatus(id, status) {
         this.loading = true;
         this.$http({
            method: 'GET',
            url: this.$util.domain + '/adminapi/v70310/platformDecoration/changeStatus',
            params: { id, status },
         }).then((res) => {
            if (res.body.error === 10000) {
               this.$message.success('操作成功');
               this.queryList();
            } else {
               this.$message.error(res.body.message || '操作失败');
            }
         }).catch((err) => {
            console.error(LOG_TAG, '修改状态失败', err);
            this.$message.error('操作失败，请联系管理员');
         }).finally(() => {
            this.loading = false;
         });
      },

      changeCurrentPage(page) {
         this.queryForm.pageNumber = page;
         this.queryList();
      },
   },
};
</script>

<style scoped>
.img-cell {
   display: flex;
   flex-wrap: wrap;
   align-items: center;
   justify-content: center;
   gap: 4px;
}

.img-preview-link {
   color: #409eff;
   cursor: pointer;
   font-size: 13px;
}

.multi-img-row {
   display: flex;
   flex-wrap: wrap;
   gap: 4px;
   justify-content: center;
}

.thumb-img {
   width: 40px;
   height: 40px;
   object-fit: cover;
   cursor: pointer;
   border-radius: 2px;
}

.list-img {
   height: 60px;
   max-width: 120px;
   object-fit: contain;
   cursor: pointer;
   border-radius: 2px;
}

.status-active  { color: #67c23a; }
.status-pending { color: #e6a23c; }
.status-disabled{ color: #909399; }
.status-expired { color: #f56c6c; }

.req-star {
   color: #f56c6c;
   margin-right: 2px;
}

.form-hint {
   font-size: 12px;
   color: #909399;
   margin-top: 4px;
   line-height: 1.4;
}

.form-hint-warn {
   color: #e6a23c;
}

.time-range-row {
   display: flex;
   align-items: center;
}

.time-range-sep {
   padding: 0 12px;
   color: #606266;
   font-size: 14px;
}

/* 主题配置 - 底部tab */
.theme-tab-wrap {
   width: fit-content;
   min-width: 320px;
}

.theme-tab-box {
   position: relative;
   border: 1px solid #bfcbd9;
   border-radius: 8px;
   padding: 10px 10px 4px;
   margin-bottom: 20px;
}

.theme-tab-close-btn {
   position: absolute;
   top: -10px;
   right: -10px;
   font-size: 20px;
   color: #909399;
   cursor: pointer;
   background: #fff;
   border-radius: 50%;
   line-height: 1;
}

.theme-tab-close-btn:hover {
   color: #f56c6c;
}

.theme-tab-imgs {
   display: flex;
   flex-direction: row;
   gap: 8px;
}

.theme-tab-img-item {
   display: flex;
   flex-direction: column;
   align-items: center;
}

.theme-tab-img-label {
   font-size: 12px;
   color: #606266;
   margin-bottom: 4px;
}

.theme-tab-tips {
   text-align: center;
   font-size: 12px;
   color: #909399;
   padding: 6px 0 8px;
}

/* 上传框缩小为 90px */
.theme-tab-imgs /deep/ .up-box,
.theme-tab-imgs /deep/ .el-upload--picture-card,
.theme-tab-imgs /deep/ .el-upload-list--picture-card .el-upload-list__item {
   width: 90px;
   height: 90px;
   line-height: 90px;
}

/* 主题配置 - 背景图 */
.theme-bg-row {
   display: flex;
   flex-wrap: wrap;
   gap: 12px;
}

.theme-bg-item {
   width: 148px;
}

.theme-bg-label {
   font-size: 12px;
   color: #606266;
   margin-bottom: 4px;
}
</style>

<style>
.platform-decoration-dialog .el-range-separator {
   padding: 0 10px;
   min-width: 46px;
}
</style>



// WEBPACK FOOTER //
// PlatformDecoration.vue?5ae6f8ce